module.exports = __webpack_public_path__ + "media/images/category/feature/coj_b/og-coj_b-43ef88272fdbe04b05220c822dd59289.png";